<section class="unauthorized">
  <div class="img-wrapper">
    <img alt="unauthorized access" src="assets/illustrations/warning.svg" />
  </div>
  <h1 class="mt-48" translate>Unauthorized Access</h1>
  <button (click)="navigateToPreviousPage()" class="button button-primary-outline button-small button-prefix-icon-start mt-30">
    <app-icon color="var(--orange)" iconName="chevron-left" marginRight="5px"></app-icon>
    {{ 'Back' | translate }}
  </button>
</section>
